"use strict";

class StationSettingsDarFMOverviewCtrl
{
    constructor($rootScope, $http, $mdToast, $scope, $mdDialog, $state)
    {
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.custom_radiovis_fqdn = false;
        this.streams = {};
        this.modelTypes = {};
        this.bearers = [];
        this.codes = [
            'song',
            'ad',
            'news',
            'weather',
            'traffic',
            'psa',
            'show'
        ];

        this.connectedradio_types = [
            'MUS',
            'COM',
            'OTH'
        ];

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        this.fetch();

        // $scope.$watch(() => {
        //     return $scope.darfmform.$invalid;
        // },(newVal) => {
        //     $rootScope.saveDisabled = newVal;
        // });
        //
        // this.exportData = {
        //     darfm: {},
        // };
        //
        // $rootScope.saveSettings = () => {
        //     this.save();
        // };
    }

    fetch()
    {
        this.$http.get('/stationsettings/export/darfm').then(response => {

            this.exportData = response.data;

            // console.log(this.exportData)
            //
            if(!this.exportData.darfm.mappings) {
                this.exportData.darfm.mappings = [];
            }
        });

        this.$http.get('/stationsettings/exportinfo').then(response => {
            this.streams = response.data.streams;
            this.modelTypes = response.data.modelTypes;
        });
    }

    save(  deleteMapping  ) {
        this.$rootScope.buttonDisabled = true;
        this.$http.put('/stationsettings/export', this.exportData).then(() => {

            if( !deleteMapping ) {
                this.$mdToast.show({
                   templateUrl: '/partial/app.partials.toasts.object_saved?object=DarFM', //@trans('labels.Export')
                   hideDelay: 6000,
                   position: ('top right')
                });
                this.$rootScope.buttonDisabled = false;
            }
        });
    }

    checkActiveItem( index ) {
        return this.$state.params.itemId == index;
    }

    addNewMapping() {
        let index = this.exportData.darfm.mappings.push({});
        this.openItem(index-1);
    }

    openItem( index ) {
        this.$state.go('stationsettings.export.darfm.item', {itemId: index});
    }

    getFieldValuesOfType(id) {
        let fields = {};
        angular.forEach(this.modelTypes, (modelType) => {
            if(modelType.id == id) {
                fields = modelType.fields;
            }
        });
        return fields;
    }

    onCloseModelTypeSelect(object) {
        if (object.title) {
            object.title = null;
        }
        if (object.artist) {
            object.artist = null;
        }
        if (object.album) {
            object.album = null;
        }
        if (object.label) {
            object.label = null;
        }
        if (object.art_url) {
            object.art_url = null;
        }
        if (object.target_url) {
            object.target_url = null;
        }
    }

    deleteMapping(mapping, index, ev) {

        ev.stopPropagation();

        this.$mdDialog.show( {

            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then( () => {

            this.exportData.darfm.mappings.splice(index, 1);
            this.save(true);

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.delete?object=item&title=DarFM',
                hideDelay: 6000,
                position: ('top right')
            });
        });
    }

    showMusicFields(code) {
        return code == 'song' || code == undefined;
    }
}

StationSettingsDarFMOverviewCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$scope', '$mdDialog', '$state'];

module.exports = StationSettingsDarFMOverviewCtrl;
